import { create, StateCreator } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createSelectors } from './utils';

interface InboxState {
  chatInputHeight: number | null;
  setChatInputHeight: (height?: number | null) => void;
}

const chatInputInitializer: StateCreator<InboxState> = (set) => ({
  chatInputHeight: null,
  setChatInputHeight: (height?: number | null) => set({ chatInputHeight: height ?? null }),
});

const useChatInputStoreRaw = create<InboxState, [['zustand/persist', unknown]]>(
  persist(
    (...args) => ({
      ...chatInputInitializer(...args),
    }),
    {
      name: 'pt-chat-input-height',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export const useChatInputStore = createSelectors(useChatInputStoreRaw);
